<template>
  <md-modal-dialog
    class="md-dialog"
    @md-opened="event = 'md-opened'"
    :md-click-outside-to-close="false"
    @md-clicked-outside="onModalClose"
  >
    <ModalWrapper>
      <div class="modal" role="dialog" aria-modal="true" aria-live="assertive" aria-labelledby="t-c-title">
        <button class="btn-close" aria-label="Close" @click="onModalClose">
          <IconCross />
        </button>
        <PrivacyText />
      </div>
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import Vue from 'vue';
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import IconCross from '@components/svg/cross.vue';
import PrivacyText from '@common/texts/privacy-policy-text';

export default Vue.component('T-C-Dialog', {
  components: {
    ModalWrapper,
    IconCross,
    PrivacyText,
  },
  data() {
    return {
      endDate: 'February 28, 2023',
    };
  },
  methods: {
    onModalClose() {
      this.$modal.submit(null);
    },
  },
});
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary);
  --md-theme-default-primary-on-background: var(--primary);
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(221, 217, 217, 0.87)
  ); */
  --max-dialog-width: 940px;
}

.modal {
  max-height: 50vh;
  overflow: auto;
}

.btn-close {
  top: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s ease background;
  padding: 20px 20px 11px;
  border-radius: 0 19px 0 20px;
  z-index: 1;
  position: absolute;
  font-size: 24px;
  color: #fff;
  appearance: none;
  border: none;
  cursor: pointer;
}
</style>
<style>
.box-wrapper .box {
  padding: 40px;
}
</style>
